<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <DiscountCreateAndUpdateFormItems :form="form" :data="discountCoupon" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import DiscountCreateAndUpdateFormItems from '@/components/DiscountCreateAndUpdateFormItems.vue'
import VForm from '@/components/VForm.vue'

export default {
    components: {
        DiscountCreateAndUpdateFormItems,
        VForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        discountCoupon () {
            return this.$store.getters[Getters.discount.GET_DISCOUNT_COUPON](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_DISCOUNT_COUPON, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
